
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[slug]",
      function () {
        return require("private-next-pages/services/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[slug]"])
      });
    }
  